import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noValue: {
		id: 'servicedesk-insight-status-picker.common.status.no-value',
		defaultMessage: 'None',
		description: 'Label for dropdown select menu for the none option',
	},
});
